<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie'
import { onMounted, ref } from 'vue'
import TapJSON from '@/assets/screen-tap-guide.json'
import SwipeGuide from '@/assets/swipe_guide.json'

const isRight = ref(true)
const showSwipeGuide = ref(true)

onMounted(() => {
  setTimeout(() => {
    showSwipeGuide.value = false
    setTimeout(() => {
      isRight.value = false
    }, 1500)
  }, 1500)
})
</script>

<template>
  <div
    v-if="showSwipeGuide"
    class="fixed flex items-center justify-center h-full w-full z-99"
  >
    <vue3-lottie :animation-data="SwipeGuide" :speed="1.2" />
  </div>
  <div
    v-else
    :class="`tip-wrapper tip-wrapper-${isRight ? 'right' : 'left'} fixed flex flex-col items-center justify-center h-full w-50% z-300`"
  >
    <p class="tip-font text-5 font-bold ">
      {{ isRight ? 'Right' : 'Left' }} tap<br>to {{ isRight ? 'next' : 'previous' }} chat
    </p>
    <vue3-lottie :animation-data="TapJSON" :speed="1.2" :height="250" :width="250" />
  </div>
</template>

<style scoped>
.tip-wrapper {
  transition: all 0.3s ease-in-out;
}
.tip-wrapper-right {
  right: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.02) 100%);
}

.tip-wrapper-left {
  left: 0;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.02) 100%);
}

.tip-font{
  color: var(--dark-gray-primary-text, #FFF);
  text-align: center;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.50);
}
</style>
